import { FC } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../../hooks/UseCheckDevice';
import { ButtonWrapper, ModalFooter } from '../UserProfileStyles';

type UserProfileModalFooterProps = {
  showChangePassword: boolean;
  isSaving: boolean;
};

const UserProfileModalFooter: FC<UserProfileModalFooterProps> = ({
  showChangePassword,
  isSaving,
}) => {
  const { isMobileDevice } = useCheckDevice();

  return (
    <ModalFooter>
      <RowWrapper>
        <ColumnWrapper className='col-sm-9' textAlign='left' marginBottom='15'>
          {showChangePassword && <span>* required fields</span>}
        </ColumnWrapper>
        <ColumnWrapper className='col-sm-3' textAlign='right'>
          <ButtonWrapper
            type='submit'
            isDisable={isSaving}
            width={isMobileDevice ? '100%' : ''}
            paddingTopBottom='6'
            paddingRightLeft='12'
            disabled={isSaving}
          >
            {!isSaving ? 'Save Changes' : 'Saving...'}
          </ButtonWrapper>
        </ColumnWrapper>
      </RowWrapper>
    </ModalFooter>
  );
};

export default UserProfileModalFooter;

type ColumnWrapperProps = {
  textAlign: string;
  marginBottom?: string;
};

const RowWrapper = styled.div`
  margin-right: -15px;
  margin-left: -15px;
`;

const ColumnWrapper = styled.div<ColumnWrapperProps>`
  position: relative;
  min-height: 1px;
  padding-left: 15px;
  text-align: ${(props) => props.textAlign};
  float: left;
  margin-bottom: ${(props) => props.marginBottom}px;
  width: 100%;
`;
